export const normalizeKraNameTokens = (value = "") =>
  String(value || "")
    .toUpperCase()
    .replace(/[^A-Z0-9\s]/g, " ")
    .split(/\s+/)
    .map((token) => token.trim())
    .filter((token) => token.length > 1)

export const areCloseNameTokens = (left = "", right = "") => {
  const a = String(left || "").trim()
  const b = String(right || "").trim()

  if (!a || !b) return false
  if (a === b) return true
  if (a[0] !== b[0]) return false

  const shorter = a.length <= b.length ? a : b
  const longer = a.length <= b.length ? b : a

  if (shorter.length < 3) return false
  if (longer.length - shorter.length > 1) return false

  if (longer.startsWith(shorter)) {
    return true
  }

  let mismatches = 0
  let shortIndex = 0
  let longIndex = 0

  while (shortIndex < shorter.length && longIndex < longer.length) {
    if (shorter[shortIndex] === longer[longIndex]) {
      shortIndex += 1
      longIndex += 1
      continue
    }

    mismatches += 1
    if (mismatches > 1) {
      return false
    }
    longIndex += 1
  }

  return true
}

export const doNamesReluctantlyMatch = (providedName = "", kraName = "") => {
  const providedTokens = normalizeKraNameTokens(providedName)
  const kraTokens = normalizeKraNameTokens(kraName)

  if (providedTokens.length === 0 || kraTokens.length === 0) {
    return false
  }

  if (providedTokens.join(" ") === kraTokens.join(" ")) {
    return true
  }

  if (providedTokens.length < 2 || kraTokens.length < 2) {
    return false
  }

  const remainingKraTokens = [...kraTokens]
  let matchedCount = 0

  for (const token of providedTokens) {
    const exactIndex = remainingKraTokens.indexOf(token)
    if (exactIndex >= 0) {
      remainingKraTokens.splice(exactIndex, 1)
      matchedCount += 1
      continue
    }

    const looseIndex = remainingKraTokens.findIndex((kraToken) =>
      areCloseNameTokens(token, kraToken)
    )
    if (looseIndex >= 0) {
      remainingKraTokens.splice(looseIndex, 1)
      matchedCount += 1
    }
  }

  return matchedCount >= 2
}

export const maskKraPin = (value = "", visibleChars = 0, maskedChars = 5) => {
  const raw = String(value || "").trim()
  if (!raw) {
    return ""
  }

  const safeVisibleChars = Math.max(0, Number(visibleChars) || 0)
  const safeMaskedChars = Math.max(0, Number(maskedChars) || 0)

  if (raw.length <= safeMaskedChars) {
    return "X".repeat(raw.length)
  }

  const visiblePart = raw.slice(0, Math.max(0, raw.length - safeMaskedChars))
  const preservedSuffix = safeVisibleChars > 0 ? raw.slice(-safeVisibleChars) : ""

  if (safeVisibleChars > 0 && visiblePart.length <= preservedSuffix.length) {
    return `${raw.slice(0, Math.max(0, raw.length - safeVisibleChars))}${"X".repeat(safeVisibleChars)}`
  }

  return `${visiblePart}${"X".repeat(safeMaskedChars)}`
}
